import React from 'react';
import { formatDistanceToNow } from "date-fns";
import { Link } from "react-router-dom";
import { Loader, User } from "lucide-react";
import { Button } from "../ui/button";

const UserIssuesTable = ({ users, isLoading }) => {
  const timeAgo = (date) => date ? formatDistanceToNow(new Date(date), { addSuffix: true }) : 'N/A';

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="flex items-center gap-2">
            { isLoading ? <Loader className="h-5 w-5 text-indigo-500 animate-spin"/> : <User className="h-5 w-5 text-indigo-500" /> }
            <h3 className="text-base font-semibold">
              Top Users With Issues
            </h3>
          </div>
          <p className="text-sm text-gray-500">
            Priority support requests needing immediate attention
          </p>
        </div>
      </div>

      <div className="overflow-x-auto flex-grow">
        <table className="w-full">
          <thead>
            <tr className="text-left text-xs text-gray-500 border-b border-solid border-slate-200">
              <th className="pb-2 font-bold">User</th>
              <th className="pb-2 font-bold">Issues</th>
              <th className="pb-2 font-bold">Reported</th>
            </tr>
          </thead>
          <tbody>
            {users?.map((user, index) => (
              <tr key={index} className="border-b border-solid border-slate-200">
                <td className="py-2.5 font-medium text-sm">
                  <Link to={`/admin/user-status/${user.userId}`}>
                    {user.userEmail || 'Public User'}
                  </Link>
                </td>
                <td className="py-2.5">
                  <div className="flex items-center">
                    <span className="inline-flex items-center justify-center w-6 h-6 mr-2 text-xs rounded-full bg-red-100 text-red-500">!</span>
                    {user.issueCount}
                  </div>
                </td>
                <td className="py-2.5 text-sm">
                  {timeAgo(user.lastIssueDate)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 flex justify-end">
        <Button variant="outline" size="sm" asChild>
          <Link to="/admin/users">View All User Issues →</Link>
        </Button>
      </div>
    </div>
  );
};

export default UserIssuesTable;
